import styled from "styled-components";


export const Container = styled.section`
  margin-top: 15rem;
  
  h2{
    text-align: center;
    font-size: 4rem;
    margin-bottom: 3rem;
  }
  .projects{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: auto;
    gap: 2rem;
    padding: 1rem;
    overflow: hidden;

    .project{
      padding: 2rem 1.8rem;
      background: linear-gradient(180deg, rgba(255,255,255,0.02), rgba(255,255,255,0.01));
      border: 1px solid var(--glass-border);
      border-radius: 14px;
      transition: transform 220ms ease, box-shadow 220ms ease, border-color 220ms ease;
      display: flex;
      flex-direction: column;
      height: 100%;
      color: var(--text);
      box-shadow: 0 8px 30px rgba(2,6,23,0.55);
      backdrop-filter: blur(6px) saturate(1.05);
      &:hover{
        transform: translateY(-8px);
        border-color: rgba(124,77,255,0.6);
        box-shadow: 0 18px 50px rgba(2,6,23,0.6);
      }

      header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: var(--blue);
        margin-bottom: 3.6rem;
        .project-links{
          display: flex;
          align-items: center;
          gap: 1rem;
        }
        svg{ background: linear-gradient(90deg,var(--accent-1),var(--accent-2)); padding: 8px; border-radius: 10px; box-shadow: 0 6px 18px rgba(2,6,23,0.5); }
        a > img {
          width: 5.0rem;
        }
      }
      
      h3{
        margin-bottom: 2rem;
      }

      p{
        letter-spacing: 0.12rem;
        margin-bottom: 2rem;
        a{
          color: #FFFF;
          border-bottom: 1px solid var(--green);
          transition: color 0.25s;
          &:hover{
            color: var(--green);
          }
        }
      }

      footer{
        margin-top: auto;
        .tech-list{
          display: flex;
          align-items: center;
          gap: 0.8rem;
          flex-wrap: wrap;
          font-size: 1.4rem;
          opacity: 0.95;
        }
        .tech-list li{
          background: linear-gradient(180deg, rgba(255,255,255,0.02), rgba(255,255,255,0.01));
          border: 1px solid var(--glass-border);
          padding: 0.35rem 0.8rem;
          border-radius: 999px;
          font-size: 1.3rem;
          color: var(--text);
          box-shadow: 0 6px 18px rgba(2,6,23,0.45);
        }
        .project-actions{
          display:flex; gap:0.8rem; margin-top:1rem; align-items:center;
        }
        .project-actions .button{
          padding: 0.5rem 1rem; font-size:1.4rem;
          background: linear-gradient(90deg,var(--accent-1),var(--accent-2));
          border-radius: 999px;
        }
      }

    }
  }

  @media (max-width: 960px){
    .projects{
      grid-template-columns: 1fr 1fr;
    }
  }

  @media (max-width: 740px){
    .projects{
      grid-template-columns: 1fr;
    }
  }
`